import React from 'react';

function Features() {
  return (
    <div className="features" id="intro">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <span className="text-zh">專業權威</span>
            <span className="text-en">Professional and Authoritative</span>
          </h1>
          <p className="hero-description">
            <span className="text-zh">
              收藏有價，鑑定無憂：即刻提升您的卡牌價值。<br />
              只需輸入 HKG CARDZ 編號, 即可秒速獲取卡牌評級。無論是初入收藏還是資深藏家, 都能精準掌握卡牌的增值潛力。數據直接對接 HKG CARDZ 官方, 確保每一筆查詢都真實權威, 讓您的收藏更有保障。
            </span>
            <span className="text-en">
              Value Your Passion, Grade with Confidence: Elevate Your Collection Today.<br />
              Simply enter a HKG CARDZ certification number to instantly access grading and comprehensive card data. From beginners to elite collectors, we help you master and enhance your card's market value. With direct integration to HKG CARDZ official records.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Features;
